const { $ } = window

const DEBUG = false
export default {
    init() {
        if ($('.swg-wrap').length) {
            //subsuccess or school-insights, not case-study or any other category or nested category of
            $('.swg-wrap').on('click', function (e) {
                //close other dropdowns
                $('.swg-open')
                    .not(this)
                    .removeClass('swg-open')
                    .find('.swg-dropdown')
                    .addClass('swg-hidden')

                if (!e.target.closest('.swg-dropdown')) {
                    $(this)
                        .toggleClass('swg-open')
                        .find('.swg-dropdown')
                        .toggleClass('swg-hidden')

                    this.querySelector('.archive-filter__search').focus()
                }
            })

            $(document).on('click', function (e) {
                if (!e.target.closest('.archive__filter')) {
                    // close all dropdowns
                    $('.swg-wrap')
                        .removeClass('swg-open')
                        .find('.swg-dropdown')
                        .addClass('swg-hidden')
                }
            })

            // setup functionalitiy
            handleCategorySearch()
            handleFilterSelection()
            handleFilterSearch()
            handleReset()

            // init
            adjustFilterDropdowns()
            submitAjaxRequest()
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
}

function handleLoading() {
    $('.category__loading').removeClass('hidden')
    $('.category__no-posts').addClass('hidden')
}

function adjustFilterDropdowns() {
    //pull values from url and process
    let url = new URL(window.location.href)
    for (let filter of document.querySelectorAll('.archive__filter')) {
        let filterActiveText = filter.querySelector('.swg-label')
        let filterSelection = filter.getAttribute('data-filter')
        let filterValues = url.searchParams.get(filterSelection)
        if (filterValues) {
            const dropdownFilterText = filterValues
                .split('+') //.filter( (v) => v )
                .map((el) => {
                    try {
                        return document
                            .querySelector(`[data-value=${el}]`)
                            .innerText.trim()
                    } catch (e) {
                        console.warn(e)
                    }
                })
                .sort()
                .join(', ')
            if (dropdownFilterText) {
                filterActiveText.innerText = dropdownFilterText
            }
        }
    }
}

// Function to handle AJAX search
function submitAjaxRequest() {
    let url = new URL(window.location.href)

    let pagenum = url.searchParams.get('pagenum')
    if (!url.searchParams.get('pagenum')) {
        pagenum = 1
    }

   //  let resourceType = ''
   //  if (url.searchParams.get('resource_type')) {
   //      resourceType = url.searchParams.get('resource_type')
   //  }

    let searchQuery = ''
    if (url.searchParams.get('search')) {
        searchQuery = url.searchParams.get('search')
    }

    let filterSelection = {
       category: [],
       resource_type: [],
       topic: [],
    }
    for (let [key, value] of url.searchParams.entries()) {
        if (Object.keys(filterSelection).includes(key)) {
            filterSelection[key] = value.split('+').filter((v) => v)
        }
    }

    let data = {
        action: 'category_load_posts',
        nonce: category_ajax_obj.nonce,
        parent_category: category_ajax_obj.parent_category,
        pagenum: pagenum,
        search: searchQuery,
        //filters
        category: filterSelection.category,
        resource_type: filterSelection.resource_type,
        topic: filterSelection.topic,
    }

    console.log(data)

    if (
        Object.keys(filterSelection).filter(
            (key) => filterSelection[key].length
        ).length ||
        searchQuery
    ) {
        $('.archive__filter-search__reset__button').addClass(
            'show-reset__button'
        )
    } else {
        $('.archive__filter-search__reset__button').removeClass(
            'show-reset__button'
        )
    }

    $.ajax({
        url: category_ajax_obj.ajax_url,
        type: 'post',
        data: data,
        success: function (response) {
            if (response.success) {
               //if(response.data.data)
                $('#post-grid').html(response.data.data)
                if (response.data.pagination) {
                    $('.pagination').html(response.data.pagination)

                    document.querySelectorAll('.pagination a').forEach((el) => {
                        el.addEventListener('click', function (e) {
                            e.preventDefault()
                            const hrefPageNum = new URL(this.href)
                            const pagenum =
                                hrefPageNum.searchParams.get('pagenum')
                            const url = new URL(window.location.href)
                            if (pagenum) {
                                url.searchParams.set('pagenum', pagenum)
                            }
                            window.history.replaceState({}, '', url)
                            submitAjaxRequest()

                            $('html, body').animate(
                                {
                                    scrollTop:
                                        $('#post-grid').offset().top -
                                        $('.navbar-wrap').height() -
                                        48,
                                },
                                800
                            )
                        })
                    })
                } else {
                    //less than one page of results
                    $('.pagination').empty()
                }
                $('.category__no-posts').addClass('hidden')
            } else {
                $('#post-grid').empty()
                $('.pagination').empty()
                $('.category__no-posts').removeClass('hidden')
            }
        },
    })
}

function updateURLSearchParameter() {
    //query) {
    // Replace with your code to update the URL search parameter
    const url = new URL(window.location.href)
    const query = document.querySelector('input#archive-search').value.trim()
    if (query) {
        url.searchParams.set('search', query)
    } else {
        url.searchParams.delete('search')
    }
    url.searchParams.delete('pagenum')
    window.history.replaceState({}, '', url)
}

function handleCategorySearch() {
    let typingTimer // Timer identifier
    let debounceInterval = 200 // Time in milliseconds to wait after typing stops

    const searchInput = document.getElementById('archive-search') // Replace with your search input's ID
    let currentValue = searchInput.value.trim() // Get the trimmed value from the input field

    // Event listener for typing; include pasted content handling
    searchInput.addEventListener('input', () => {
        clearTimeout(typingTimer) // Clear the previous timer

        // handleLoading()

        // Start a new timer
        typingTimer = setTimeout(() => {
            const query = searchInput.value.trim() // Get the trimmed value from the input field
            if (query !== currentValue) {
                // dont submit if user is selecting all text (no actual value change)
                currentValue = query
                updateURLSearchParameter() //query) // Submit the search query
                submitAjaxRequest() //query) // Submit the search query
            }
        }, debounceInterval)
    })

    //  // Optional: Clear the timer if the user presses a key, preventing the search
    //  searchInput.addEventListener('keydown', () => {
    //      clearTimeout(typingTimer) // Clear the timer on keydown
    //  })
}

function handleFilterSearch() {
    let typingTimer // Timer identifier
    let debounceInterval = 200 // Time in milliseconds to wait after typing stops

    const filterSearchInputs = document.querySelectorAll(
        '.archive__filter__search'
    )

    // Event listener for typing
    filterSearchInputs.forEach((searchInput) => {
        const parentDropdown = searchInput.closest('.swg-dropdown')
        const optionsContainer = parentDropdown.querySelector('.swg-options')
        const options = parentDropdown.querySelectorAll('.swg-option')
        const noOptionsText = parentDropdown.querySelector('.swg-no-results')

        searchInput.addEventListener('input', () => {
            clearTimeout(typingTimer) // Clear the previous timer

            optionsContainer.classList.remove('swg-hidden')
            noOptionsText.classList.add('swg-hidden')

            // Start a new timer
            typingTimer = setTimeout(() => {
                const query = searchInput.value.trim() // Get the trimmed value from the input field

                //filter dropdown items
                let count = 0
                options.forEach((option) => {
                    if (
                        option.innerText
                            .toLowerCase()
                            .includes(query.toLowerCase())
                    ) {
                        option.style.display = 'block'
                        count++
                    } else {
                        option.style.display = 'none'
                    }
                })
                if (count == 0) {
                    //show no filters text
                    optionsContainer.classList.add('swg-hidden')
                    noOptionsText.classList.remove('swg-hidden')
                }
            }, debounceInterval)
        })
    })
}

function handleFilterSelection() {
    let url = new URL(window.location.href)

    for (let [key, value] of url.searchParams.entries()) {
        let values = value.split('+').filter((v) => v) // not empty string

        if (!Object.keys(values).length) {
            continue
        }

        for (let v of values) {
            try {
                document
                    .querySelector(`.g0[data-value="${v}"]`)
                    .classList.add('selected') //assumes no overlap between filters in using as identifying factor
            } catch (e) {
                console.warn(e)
            }
        }
    }

    $('.g0').on('click', function () {
        //related to search
        $(this).siblings().show()
        let searchInput = this.closest('.swg-dropdown').querySelector(
            '.archive__filter__search'
        )
        searchInput.value = ''
        searchInput.focus()

        this.classList.toggle('selected')
        const filter =
            this.closest('.archive__filter').getAttribute('data-filter')
        const value = this.getAttribute('data-value')

        const url = new URL(window.location.href)
        let filterValues = url.searchParams.get(filter)
        if (filterValues) {
            filterValues = filterValues.split('+').filter((v) => v)
        } else {
            filterValues = []
        }
        if (filterValues && filterValues.includes(value)) {
            filterValues = filterValues.filter((v) => v !== value)
        } else {
            filterValues.push(value)
        }

        let filterEl = this.closest('.archive__filter')
        let filterActiveText = filterEl.querySelector('.swg-label')
        if (filterValues.length) {
            url.searchParams.set(filter, filterValues.join('+'))
            filterActiveText.innerText = filterValues
                .map((el) => {
                    try {
                        return document.querySelector(`[data-value=${el}]`)
                            .innerText
                    } catch (e) {
                        console.warn(e)
                    }
                })
                .filter((v) => v)
                .join(', ')
        } else {
            url.searchParams.delete(filter)
            filterActiveText.innerText =
                filterEl.getAttribute('data-filter-name')
        }

        url.searchParams.delete('pagenum')
        window.history.replaceState({}, '', url)
        submitAjaxRequest()
    })
}

function handleReset() {
    const $resetButtons = $('.archive__filter-search__reset__button')
    if (!$resetButtons.length) {
        return
    }

    const $archiveFilters = $('.archive__filter')
    const $archiveFiltersItems = $('.g0')
    const $archiveSearches = $('.archive__search')

    $resetButtons.on('click', function () {
        $archiveFiltersItems.removeClass('selected')
        $archiveFilters.each((_index, element) => {
            $(element)
                .find('.swg-label')
                .text($(element).attr('data-filter-name'))
        })
        $archiveSearches.find('input#archive-search').each((index, element) => {
            element.value = ''
        })

        //update url
        const url = new URL(window.location.href)
        url.searchParams.delete('category')
        url.searchParams.delete('resource_type')
        url.searchParams.delete('search')
        url.searchParams.delete('topic')
        url.searchParams.delete('pagenum')
        window.history.replaceState({}, '', url)

        //update DOM
        submitAjaxRequest()
    })
}
